import apiClient from "./axios"

export const getPrayerTrackerReport = async (params = {}) => {
  const { data } = await apiClient.get("/prayer-logs/report", { params })
  return data
}
